// Mobile nav drawer toggle.
//   • hamburger (`[data-nav-toggle]`) → opens the drawer
//   • close button + backdrop (`[data-nav-close]`) → close it
//   • Escape key → close it
//   • body locks scroll when drawer is open (`.nav-open` class)

const toggle = document.querySelector('[data-nav-toggle]');
const nav    = document.querySelector('.site-nav');
const closes = document.querySelectorAll('[data-nav-close]');

function setOpen(open) {
    if (!toggle || !nav) return;
    toggle.setAttribute('aria-expanded', String(!!open));
    nav.classList.toggle('is-open', !!open);
    document.body.classList.toggle('nav-open', !!open);
}

if (toggle && nav) {
    toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    closes.forEach((el) => el.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
            setOpen(false);
            toggle.focus();          // return focus to the trigger for keyboard users
        }
    });

    // Any link inside the drawer closes it on click — feels natural on
    // phones and the new page will scroll to the top after navigation.
    nav.addEventListener('click', (e) => {
        if (e.target instanceof HTMLAnchorElement) setOpen(false);
    });
}
